var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnDocVente(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 15") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-app-particuliers",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI-APP---Particuliers-tableau-de-bord-02a",
    transform: "translate(-330, -1241)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(330, 1241)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#173B3C",
    cx: 30,
    cy: 30,
    r: 30
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(19, 17)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.727381,22.0042105 C20.727381,22.9621053 19.9607143,23.7284211 19.002381,23.7284211 L3.99761905,23.7284211 C3.03928571,23.7284211 2.27261905,22.9621053 2.27261905,22.0042105 L2.27261905,3.99578947 C2.27261905,3.03789474 3.03928571,2.27157895 3.99761905,2.27157895 L19.0297619,2.27157895 C19.9880952,2.27157895 20.7547619,3.03789474 20.7547619,3.99578947 L20.7547619,22.0042105 L20.727381,22.0042105 Z M19.002381,0 L3.99761905,0 C1.7797619,0 0,1.77894737 0,3.99578947 L0,22.0042105 C0,24.1936842 1.7797619,26 3.99761905,26 L19.0297619,26 C21.2202381,26 23,24.2210526 23,22.0042105 L23,3.99578947 C23,1.77894737 21.2202381,0 19.002381,0 L19.002381,0 Z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9904762,6.40421053 L7.00952381,6.40421053 C6.3797619,6.40421053 5.85952381,6.92421053 5.85952381,7.55368421 C5.85952381,8.18315789 6.3797619,8.70315789 7.00952381,8.70315789 L15.9904762,8.70315789 C16.6202381,8.70315789 17.1404762,8.18315789 17.1404762,7.55368421 C17.1404762,6.92421053 16.6202381,6.40421053 15.9904762,6.40421053",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9904762,11.8505263 L7.00952381,11.8505263 C6.3797619,11.8505263 5.85952381,12.3705263 5.85952381,13 C5.85952381,13.6294737 6.3797619,14.1494737 7.00952381,14.1494737 L15.9904762,14.1494737 C16.6202381,14.1494737 17.1404762,13.6294737 17.1404762,13 C17.1404762,12.3705263 16.6202381,11.8505263 15.9904762,11.8505263",
    id: "Fill-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9904762,17.2968421 L7.00952381,17.2968421 C6.3797619,17.2968421 5.85952381,17.8168421 5.85952381,18.4463158 C5.85952381,19.0757895 6.3797619,19.5957895 7.00952381,19.5957895 L15.9904762,19.5957895 C16.6202381,19.5957895 17.1404762,19.0757895 17.1404762,18.4463158 C17.1404762,17.8168421 16.6202381,17.2968421 15.9904762,17.2968421",
    id: "Fill-7"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnDocVente);
export default __webpack_public_path__ + "static/media/icn-doc-vente.a194243e3d68e56fe1ce37d4782e8c16.svg";
export { ForwardRef as ReactComponent };